package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SwordRoseW500Rounded: ImageVector
    get() {
        if (_swordRoseW500Rounded != null) {
            return _swordRoseW500Rounded!!
        }
        _swordRoseW500Rounded = Builder(name = "SwordRoseW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(888.13f, 117.37f)
                verticalLineToRelative(103.24f)
                quadToRelative(0.0f, 9.19f, -3.48f, 17.53f)
                quadToRelative(-3.48f, 8.34f, -10.19f, 15.06f)
                lineTo(682.04f, 445.61f)
                quadToRelative(-13.19f, 13.19f, -31.11f, 12.81f)
                quadToRelative(-17.91f, -0.38f, -31.1f, -13.57f)
                quadToRelative(-12.44f, -13.2f, -12.82f, -31.11f)
                quadToRelative(-0.38f, -17.91f, 12.82f, -31.11f)
                lineToRelative(179.69f, -179.7f)
                verticalLineToRelative(-42.45f)
                horizontalLineToRelative(-42.45f)
                lineToRelative(-179.7f, 179.45f)
                quadToRelative(-12.44f, 12.44f, -30.73f, 12.44f)
                reflectiveQuadToRelative(-31.49f, -12.44f)
                quadToRelative(-13.19f, -13.19f, -13.19f, -31.48f)
                quadToRelative(0.0f, -18.3f, 13.19f, -31.49f)
                lineTo(706.8f, 85.3f)
                quadToRelative(6.72f, -6.71f, 15.06f, -10.07f)
                quadToRelative(8.34f, -3.36f, 17.53f, -3.36f)
                horizontalLineToRelative(103.24f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                close()
                moveTo(133.39f, 874.22f)
                lineTo(85.3f, 826.13f)
                quadToRelative(-13.67f, -13.67f, -13.67f, -32.06f)
                quadToRelative(0.0f, -18.4f, 13.67f, -32.07f)
                lineToRelative(112.18f, -112.93f)
                lineToRelative(-61.68f, -61.68f)
                quadToRelative(-10.52f, -10.52f, -10.52f, -26.32f)
                quadToRelative(0.0f, -15.81f, 10.52f, -26.33f)
                quadToRelative(24.44f, -24.44f, 59.63f, -25.99f)
                quadToRelative(35.2f, -1.55f, 61.07f, 20.01f)
                lineToRelative(3.04f, 3.81f)
                lineToRelative(19.05f, -19.05f)
                quadToRelative(12.43f, -12.43f, 30.73f, -12.43f)
                quadToRelative(18.29f, 0.0f, 31.48f, 12.43f)
                quadToRelative(13.2f, 13.2f, 13.08f, 31.49f)
                quadToRelative(-0.12f, 18.29f, -13.31f, 31.49f)
                lineToRelative(-16.85f, 16.85f)
                lineToRelative(42.69f, 42.69f)
                lineToRelative(17.85f, -17.84f)
                quadToRelative(13.2f, -13.2f, 30.99f, -12.82f)
                quadToRelative(17.79f, 0.38f, 30.99f, 13.58f)
                quadToRelative(12.43f, 13.19f, 12.81f, 31.11f)
                quadToRelative(0.38f, 17.91f, -12.81f, 31.1f)
                lineToRelative(-19.04f, 19.05f)
                lineToRelative(3.8f, 3.04f)
                quadToRelative(21.33f, 25.87f, 19.77f, 60.95f)
                quadToRelative(-1.55f, 35.07f, -25.99f, 59.51f)
                quadToRelative(-10.52f, 10.52f, -26.32f, 10.52f)
                quadToRelative(-15.81f, 0.0f, -26.33f, -10.52f)
                lineToRelative(-61.67f, -61.68f)
                lineTo(197.52f, 874.22f)
                quadToRelative(-13.67f, 13.67f, -32.06f, 13.67f)
                reflectiveQuadToRelative(-32.07f, -13.67f)
                close()
                moveTo(840.15f, 572.02f)
                quadToRelative(4.52f, -20.61f, 0.36f, -41.22f)
                quadToRelative(-4.16f, -20.6f, -12.73f, -40.69f)
                quadToRelative(-15.08f, 14.8f, -26.41f, 32.51f)
                quadToRelative(-11.33f, 17.71f, -15.85f, 38.31f)
                quadToRelative(-4.76f, 20.85f, -0.22f, 41.08f)
                quadToRelative(4.55f, 20.23f, 12.59f, 40.08f)
                quadToRelative(14.85f, -14.81f, 26.18f, -32.01f)
                quadToRelative(11.32f, -17.21f, 16.08f, -38.06f)
                close()
                moveTo(203.89f, 329.7f)
                quadToRelative(18.04f, 18.04f, 41.23f, 24.76f)
                quadToRelative(23.18f, 6.71f, 45.47f, 0.87f)
                lineToRelative(-20.44f, -20.44f)
                quadToRelative(-16.32f, -16.32f, -38.81f, -22.11f)
                quadTo(208.85f, 307.0f, 188.0f, 313.8f)
                lineToRelative(15.89f, 15.9f)
                close()
                moveTo(276.41f, 151.61f)
                lineTo(204.35f, 222.67f)
                quadToRelative(34.56f, -1.8f, 68.27f, 10.32f)
                quadToRelative(33.71f, 12.12f, 60.51f, 38.92f)
                lineToRelative(20.2f, 20.2f)
                quadToRelative(5.84f, -22.28f, 0.13f, -45.73f)
                quadToRelative(-5.72f, -23.45f, -24.53f, -41.49f)
                lineToRelative(-52.52f, -53.28f)
                close()
                moveTo(811.67f, 874.41f)
                lineTo(357.72f, 422.46f)
                quadToRelative(-51.63f, 30.24f, -112.14f, 22.3f)
                quadToRelative(-60.51f, -7.93f, -104.67f, -52.09f)
                lineToRelative(-83.43f, -84.19f)
                quadToRelative(-6.72f, -6.72f, -10.2f, -14.91f)
                quadToRelative(-3.48f, -8.2f, -3.48f, -17.16f)
                quadToRelative(0.0f, -8.95f, 3.48f, -17.15f)
                quadToRelative(3.48f, -8.19f, 10.2f, -14.91f)
                lineToRelative(186.87f, -186.11f)
                quadToRelative(6.72f, -6.72f, 14.91f, -9.7f)
                quadToRelative(8.2f, -2.98f, 17.15f, -2.98f)
                quadToRelative(8.96f, 0.0f, 17.04f, 2.98f)
                quadToRelative(8.07f, 2.98f, 14.79f, 9.7f)
                lineToRelative(83.67f, 83.67f)
                quadToRelative(44.92f, 44.92f, 51.97f, 105.55f)
                quadToRelative(7.05f, 60.63f, -23.18f, 112.02f)
                lineTo(702.52f, 641.3f)
                quadToRelative(-6.32f, -23.37f, -7.61f, -48.26f)
                quadToRelative(-1.28f, -24.89f, 3.24f, -49.78f)
                quadToRelative(11.0f, -51.72f, 43.6f, -92.84f)
                quadToRelative(32.6f, -41.12f, 77.08f, -68.55f)
                quadToRelative(15.43f, -8.96f, 32.6f, -5.48f)
                quadToRelative(17.18f, 3.48f, 27.37f, 17.91f)
                quadToRelative(29.24f, 42.44f, 43.98f, 92.8f)
                quadToRelative(14.74f, 50.36f, 3.74f, 102.07f)
                quadToRelative(-10.76f, 50.76f, -41.78f, 90.41f)
                quadToRelative(-31.02f, 39.64f, -75.07f, 68.88f)
                lineToRelative(63.98f, 63.97f)
                quadToRelative(12.44f, 12.44f, 12.7f, 30.61f)
                quadToRelative(0.26f, 18.18f, -12.94f, 31.37f)
                quadToRelative(-12.43f, 12.44f, -30.87f, 12.44f)
                quadToRelative(-18.43f, 0.0f, -30.87f, -12.44f)
                close()
                moveTo(307.13f, 307.13f)
                close()
            }
        }
        .build()
        return _swordRoseW500Rounded!!
    }

private var _swordRoseW500Rounded: ImageVector? = null
